import { useMemo } from "react";
import { PDFTableColumn } from "components/PDF/Table";
import { View, Text } from "@react-pdf/renderer";
import { OrcamentoItem } from "features/orcamento/typings";
import { getUnidadeMedida } from "./../../util";
import { UnidadeMedidaEnum } from "core/features/orcamento/typings";

function useItensOrcamentoPdfColumns(): PDFTableColumn<OrcamentoItem>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<OrcamentoItem>[] = [];

    columns.push({
      title: "Quantidade",
      flexGrow: 0.5,
      render: (original) => (
        <View>
          <Text>
            {original.quantidade}
            {` `} {getUnidadeMedida(original.unidadeMedidaId!)}
            {original.quantidade! > 1
              ? `${
                  original.unidadeMedidaId === UnidadeMedidaEnum.Mes
                    ? "es"
                    : "s"
                }`
              : ""}
          </Text>
        </View>
      ),
    });

    columns.push({
      title: "Item",
      flexGrow: 2,
      render: (original) => (
        <View>
          <Text>{original.nome}</Text>
        </View>
      ),
    });

    return columns;
  }, []);
}

export default useItensOrcamentoPdfColumns;
